
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2018/02/gaiq-exam-in-30mins",
      function () {
        return require("private-next-pages/blog-post/2018/02/gaiq-exam-in-30mins.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2018/02/gaiq-exam-in-30mins"])
      });
    }
  